"use client";
import { ark } from "../factory.js";
import { useProgressContext } from "./use-progress-context.js";
import { forwardRef } from "react";
import { mergeProps } from "@zag-js/react";
import { jsx } from "react/jsx-runtime";
//#region src/components/progress/progress-label.tsx
var ProgressLabel = forwardRef((props, ref) => {
	const mergedProps = mergeProps(useProgressContext().getLabelProps(), props);
	return /* @__PURE__ */ jsx(ark.span, {
		...mergedProps,
		ref
	});
});
ProgressLabel.displayName = "ProgressLabel";
//#endregion
export { ProgressLabel };
